import { render, staticRenderFns } from "./AnimationSelector.vue?vue&type=template&id=b910128e&scoped=true"
import script from "./AnimationSelector.vue?vue&type=script&lang=js"
export * from "./AnimationSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b910128e",
  null
  
)

export default component.exports